import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as api from '../elements/api/api';
import { Notyf } from 'notyf';
import * as bm from '../elements/api/BookmarkManagement'




function Bookmarks(props) {


  const [bookmarks, setBookmarks] = useState([])

 const removeBookmark = (bookmark) => {
    bm.removeBookmarkFromList(bookmark)
    setBookmarks(bm.loadBookmarksFromLocalStorage())
 }

  useEffect(() => {
    setBookmarks(bm.loadBookmarksFromLocalStorage());
  },[]);

  const addBookmark = (bookmark) => {
    props.addBookmark(bookmark)
  };

  return (

    <div className="bookmarks">
      <h4>Bookmarks</h4>

      <Table striped hover>
        <thead>
          <tr>


            <th>Title</th>
            <th>{/*Tools */}</th>
          </tr>
        </thead>
        <tbody>
          {bookmarks.map((bookmark, index) => {
            return(
            <tr>
              <td>
                {/* Title */
                  <a href={bookmark[bm.CLIP_URL]} target="_blank">{  bookmark[bm.TITLE]  }</a>
                }
              </td>
              <td className="tools">
                {/* Add */}
                <a href="javascript:;" onClick={() => addBookmark(bookmark)} ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg></a>
                {/* Remove */}
               <a href="javascript:;"onClick={() => removeBookmark(bookmark)}><svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg></a>

              </td>
            </tr>)
          })}
        </tbody>
      </Table>
    </div>);



}

export default Bookmarks;